import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule, AbstractControl, ValidationErrors } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import constant from '../../../../../src/app/app.constant';
import { CommonHttpService } from '../../../../../src/app/utils/common-http.service';
import Swal from 'sweetalert2';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { DragulaModule, DragulaService } from 'ng2-dragula';
import { OnlyNumberDirective } from '../../../directives/only-number.directive';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { catchError, combineLatest, forkJoin, map, of } from 'rxjs';
import { LocalStorageService } from '../../../utils/local-storage.service';
interface ApiResponse {
  status: boolean;
  message: string;
  data?: any;
}

interface ApiResult {
  success: boolean;
  response?: ApiResponse;
  error?: any;
}

@Component({
  selector: 'app-delivery-partner-map',
  templateUrl: './delivery-partner-map.component.html',
  styleUrls: ['./delivery-partner-map.component.scss'],
  standalone: true,
  imports: [NgSelectModule, ReactiveFormsModule, CommonModule, NgbModule, TranslateModule, FormsModule, DragulaModule, OnlyNumberDirective]
})
export class DeliveryPartnerMapComponent implements OnInit {
  public constant = constant;
  public deliveryPartnerList: any = [];
  deliveryPartnerShow: boolean = true;
  UserDeliveryPartnerMap: any = [];
  dpFormGroup: FormGroup;
  submitted = false;
  dp_rearrange_with_eta: any;
  dp_push_mechanisum: any;
  dp_name: any;
  Math = Math;
  dpList: any = [];
  dp_setup: any;
  apply_dp_setup: any;
  originalApplyDpSetup: any; // Store the original value
  kmValidationErrors: any = {}; // Track validation errors for each delivery partner

  @Output() dpRearrangEvent = new EventEmitter();
  applydpList: any = [];
  userAgencyType: any;
  // deliveryPartnerIds: any = [];
  // ondcConfigListData : any =[];
  // ondcConfigList: any = constant.ondcDpUrlList; 
  // ondcActiveCheck:boolean=false;
  constructor(private toaster: ToastrService, private router: Router, private dragulaService: DragulaService, public activeModal: NgbActiveModal, private http: CommonHttpService, private _formBuilder: FormBuilder, private localstore: LocalStorageService ) {
    this.dragulaService.createGroup("DPM", {
      // removeOnSpill: true
    });
  }
  @Input() userData: any;

  ngOnInit() {
    this.dpFormGroup = this._formBuilder.group({
      delivery_partner_user_id: [null, Validators.required],
      waiting_time_in_min: [null, [Validators.required, waitingTimeValidator]],
      // min_km: [null, [Validators.required, waitingTimeValidator]],
      // max_km: [null, [Validators.required, waitingTimeValidator]],
    });
    if (this.userData) {
      // let tempDta:any=[]
      // if(this.userData.ondc_bap_id != null){
      // this.userData.ondc_bap_id.split(',').map((item:any)=>{ tempDta.push(item.trim()) })
      // }
      // this.ondcConfigListData  = tempDta      
      this.dp_rearrange_with_eta = this.userData?.dp_rearrange_with_eta;
      this.dp_push_mechanisum = this.userData?.dp_push_mechanisum;
      this.dpList = this.userData?.dpList;
      this.dp_setup = this.userData?.dp_setup;
      this.apply_dp_setup = this.userData?.apply_dp_setup;
      this.originalApplyDpSetup = this.userData?.apply_dp_setup; // Store original value
      this.applydpList = this.userData?.applydpList;
      this.userAgencyType = this.userData?.userAgencyType;
      this.getDeliveryPartnerDetails();
    }
  }
  getDeliveryPartnerDetails() {
    this.http.get(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.DeliveryPartnerWiseOrderTime.DpOrderGetMap + '/' + this.userData?.userId).subscribe((response: any) => {
      if (response.status) {
        var deliveryPartnerList = response?.data?.DeliveryPartner
        this.UserDeliveryPartnerMap = response?.data?.UserDeliveryPartnerMap
        // this.deliveryPartnerIds = response?.data?.UserDeliveryPartnerMap.map((x:any) =>(x.delivery_partner_user_id))
        // this.ondcActiveCheck = response?.data?.UserDeliveryPartnerMap?.some((x: any) =>x.delivery_partner_user_id == constant.deliveryPartnerViaOndc && x.status == 'Active');       
        this.UserDeliveryPartnerMap = (response?.data?.UserDeliveryPartnerMap || [])
          .sort((a: any, b: any) => (a.sort_order || 0) - (b.sort_order || 0));
        if (_.isArray(this.UserDeliveryPartnerMap) && !_.isEmpty(this.UserDeliveryPartnerMap)) {
          this.deliveryPartnerList = [];
          var delivery_partner = [] = this.UserDeliveryPartnerMap?.map((element: any) => {
            if (element?.delivery_partner_user_id) {
              if (element?.delivery_partner_user_id == constant.deliveryPartnerViaOndc) {
                // this.ondcConfigListFun()
              }
              //  this.deliveryPartnerIds.push( element?.delivery_partner_user_id)
              let newDate = moment().format('x');
              element.DeliveryPartner.icon_url = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + element?.DeliveryPartner.icon_url + '&=' + newDate;
              return element.delivery_partner_user_id;
            }
          })
          deliveryPartnerList?.filter((item: any) => {
            if (!delivery_partner.includes(item.user_id)) {
              this.deliveryPartnerList.push(item);
            };
          });
          this.UserDeliveryPartnerMap?.map((element: any, index: any) => {
            element.previous_json = { ...element };
            // Validate km range for each delivery partner
            this.validateKmRange(index);
          })
        } else {
          this.deliveryPartnerList = [];
          this.deliveryPartnerList = deliveryPartnerList;
        }
      }
    })
  }
  thirdPartyMethod() {
    var reqJson: any = {
      dp_push_mechanisum: this.dp_push_mechanisum,
      user_id: this.userData.userId,
      under_user_id: this.userData.under_user_id,
      agency_user_id: this.userData.agency_user_id,
      master_agency_user_id: this.userData.master_agency_user_id,
      vendor_agency_user_id: this.userData.vendor_agency_user_id,
      under_role_id: this.userData.under_role_id,
    }
    this.dpRearrangEvent.emit({ user_id: this.userData.userId, dp_push_mechanisum: this.dp_push_mechanisum });

    this.http.updateData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.User.Update, reqJson).subscribe((response: any) => {
      if (response.status) {
        this.toaster.success('Successfully Updated')
      } else {
        this.toaster.error(response.message)
      }
    });
  }
  dpSetupMethod() {
    this.dpRearrangEvent.emit({ user_id: this.userData.userId, dp_setup: this.dp_setup });

    // if(this.userData.role_id == constant.RoleId.vendor) 
    if (this.localstore.getItem(constant.localStorage.user_role_id) == constant.RoleId.vendor) {
      const vendorReqJson: any = {
        dp_setup: this.dp_setup,

        user_id: this.userData.userId,
      };
      this.http.updateData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.User.VendorUpdate, vendorReqJson).subscribe((response: any) => {
        if (response.status) {
          this.toaster.success('Successfully Updated');
        } else {
          this.toaster.error(response.message);
        }
      });
    } else {
      const reqJson: any = {
        dp_setup: this.dp_setup,
        user_id: this.userData.userId,
        under_user_id: this.userData.under_user_id,
        agency_user_id: this.userData.agency_user_id,
        master_agency_user_id: this.userData.master_agency_user_id,
        vendor_agency_user_id: this.userData.vendor_agency_user_id,
        under_role_id: this.userData.under_role_id,
      };
      this.http.updateData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.User.Update, reqJson).subscribe((response: any) => {
        if (response.status) {
          this.toaster.success('Successfully Updated');
        } else {
          this.toaster.error(response.message);
        }
      });
    }
  }
  onApplyDpSetupChange(newValue: any) {
    // Use the stored original value
    const originalValue = this.originalApplyDpSetup;

    // // Temporarily set the new value for the confirmation dialog
    // this.apply_dp_setup = newValue?.value;

    Swal.fire({
      title: 'Apply to All Nested Customers?',
      text: "",
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        // Temporarily set the new value for the confirmation dialog
        this.apply_dp_setup = newValue?.value;
        // User confirmed, proceed with the API call
        this.applyDpSetupMethod();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // User cancelled, revert to original value
        this.apply_dp_setup = originalValue;
      }
    });
  }

  applyDpSetupMethod() {
    var reqJson: any = {
      apply_dp_setup: this.apply_dp_setup,
      dp_setup: this.dp_setup,
      user_id: this.userData.userId,
      under_user_id: this.userData.under_user_id,
      agency_user_id: this.userData.agency_user_id,
      master_agency_user_id: this.userData.master_agency_user_id,
      under_role_id: this.userData.under_role_id,
      role_id: this.userData.role_id,
    }

    this.http.postData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.User.updateDpSetup, reqJson).subscribe((response: any) => {
      if (response.status) {
        this.toaster.success('Successfully Updated');
        this.dpRearrangEvent.emit({ user_id: this.userData.userId, apply_dp_setup: this.apply_dp_setup });
        this.dpRearrangEvent.emit({ user_id: this.userData.userId, dp_setup: (this.apply_dp_setup == constant.dpSetup.masterAgency || this.apply_dp_setup == constant.dpSetup.agency) ? constant.dpSetup.own : this.apply_dp_setup });
        this.dp_setup = (this.apply_dp_setup == constant.dpSetup.masterAgency || this.apply_dp_setup == constant.dpSetup.agency) ? constant.dpSetup.own : this.apply_dp_setup
        this.originalApplyDpSetup = this.apply_dp_setup;
      } else {
        this.toaster.error(response.message)
      }
    });
  }
  deliveryPartnerAdd() {
    this.deliveryPartnerShow = false;
    this.submitted = false;
    this.dpFormGroup.reset();
  }
  backBtn() {
    this.deliveryPartnerShow = true;
  }
  ngOnDestroy() {
    this.dragulaService.destroy('DPM');
    // Clear validation errors
    this.kmValidationErrors = {};
  }
  closeModal() {
    // Clear validation errors before closing
    this.kmValidationErrors = {};
    this.activeModal.dismiss();
  }

  // editFunction(event: any, i: any, name: any) {
  //   const inputValue = event?.target?.value;

  //   // If empty, allow it (user might be typing)
  //   if (inputValue === '' || inputValue === null || inputValue === undefined) {
  //     return;
  //   }

  //   const value = Number(inputValue);

  //   // Only validate if it's a complete number (not during typing)
  //   if (inputValue.includes('.') || inputValue.includes('e')) {
  //     return; // Allow decimal and scientific notation during typing
  //   }

  //   // Validate the input
  //   if (isNaN(value)) {
  //     // Don't show error immediately, let user finish typing
  //     return;
  //   }

  //   // Update the value if it's valid
  //   if (name == 'waiting_time_in_min') {
  //     if (value >= 0) {
  //       this.UserDeliveryPartnerMap[i]['waiting_time_in_min'] = value;
  //     }
  //   }
  //   if (name == 'max_km') {
  //     this.UserDeliveryPartnerMap[i]['max_km'] = value;
  //     // Trigger km validation after updating max_km
  //     setTimeout(() => this.validateKmRange(i), 0);
  //   }
  //   if (name == 'min_km') {
  //     this.UserDeliveryPartnerMap[i]['min_km'] = value;
  //     // Trigger km validation after updating min_km
  //     setTimeout(() => this.validateKmRange(i), 0);
  //   }

  // }
  editFunction(event: any, i: any, name: any) {
    if (event?.target?.value && name == 'waiting_time_in_min') {
      this.UserDeliveryPartnerMap[i]['waiting_time_in_min'] = event?.target?.value;
    }
    if (name == 'max_km') {
      const value = event?.target?.value;
      this.UserDeliveryPartnerMap[i]['max_km'] = value;
      // Trigger km validation after updating max_km
      setTimeout(() => this.validateKmRange(i), 0);
    }
    if (name == 'min_km') {
      const value = event?.target?.value;
      this.UserDeliveryPartnerMap[i]['min_km'] = value;
      // Trigger km validation after updating min_km
      setTimeout(() => this.validateKmRange(i), 0);
    }
  }
  validateWaitingTime(event: any, i: any) {
    const inputValue = event?.target?.value;
    const partnerName = this.UserDeliveryPartnerMap[i]?.DeliveryPartner?.full_name || 'Delivery Partner';

    // If empty, set to default value of 1
    if (inputValue === '' || inputValue === null || inputValue === undefined) {
      this.UserDeliveryPartnerMap[i]['waiting_time_in_min'] = 1;
      event.target.value = 1;
      this.toaster.info(`Waiting time for ${partnerName} set to 1 minute (minimum)`);
      return;
    }

    const value = Number(inputValue);

    // Validate the input
    if (isNaN(value)) {
      this.UserDeliveryPartnerMap[i]['waiting_time_in_min'] = 1;
      event.target.value = 1;
      this.toaster.warning(`Invalid number for ${partnerName}. Set to 1 minute.`);
      return;
    }

    // Handle negative values - convert to positive
    if (value < 0) {
      const positiveValue = Math.abs(value);
      this.UserDeliveryPartnerMap[i]['waiting_time_in_min'] = positiveValue;
      event.target.value = positiveValue;
      this.toaster.info(`Negative value for ${partnerName} converted to ${positiveValue} minutes`);
      return;
    }

    // Handle values less than 1
    if (value < 1) {
      this.UserDeliveryPartnerMap[i]['waiting_time_in_min'] = 1;
      event.target.value = 1;
      this.toaster.info(`Waiting time for ${partnerName} adjusted to minimum (1 minute)`);
      return;
    }

    // Handle values greater than 60
    if (value > 60) {
      this.UserDeliveryPartnerMap[i]['waiting_time_in_min'] = 60;
      event.target.value = 60;
      this.toaster.info(`Waiting time for ${partnerName} adjusted to maximum (60 minutes)`);
      return;
    }

    // Update the value if validation passes
    this.UserDeliveryPartnerMap[i]['waiting_time_in_min'] = value;
  }

  validateKmRange(i: any) {
    const minKm = this.UserDeliveryPartnerMap[i]?.min_km;
    const maxKm = this.UserDeliveryPartnerMap[i]?.max_km;
    const partnerName = this.UserDeliveryPartnerMap[i]?.DeliveryPartner?.full_name || 'Delivery Partner';

    // Clear previous error for this partner
    this.kmValidationErrors[i] = null;

    // If both values are empty, no validation needed
    if ((minKm === null || minKm === undefined || minKm === '') &&
      (maxKm === null || maxKm === undefined || maxKm === '')) {
      return true;
    }

    // Convert to numbers for comparison
    const minKmNum = Number(minKm);
    const maxKmNum = Number(maxKm);

    // Check if min km is a valid number
    if (minKm !== null && minKm !== undefined && minKm !== '' && isNaN(minKmNum)) {
      this.kmValidationErrors[i] = `Min KM must be a valid number for ${partnerName}`;
      return false;
    };

    // Check if min km is a not 0 
    // if (minKm !== null && minKm == "'") {
    //   this.kmValidationErrors[i] = `Min KM must be greater then 0  for ${partnerName}`;
    //   return false;
    // };

    // Check if min km is a not 5 
    if (minKm !== null && minKm > 5) {
      this.kmValidationErrors[i] = `Min KM must be not greater then 5  for ${partnerName}`;
      return false;
    };

    // Check if max km is a not 50 
    if (maxKm !== null && maxKm > 50) {
      this.kmValidationErrors[i] = `Min KM must be not greater then 50  for ${partnerName}`;
      return false;
    };

    // Check if max km is a valid number
    if (maxKm !== null && maxKm !== undefined && maxKm !== '' && isNaN(maxKmNum)) {
      this.kmValidationErrors[i] = `Max KM must be a valid number for ${partnerName}`;
      return false;
    }

    // Only validate if both values are present and valid numbers
    if (!isNaN(minKmNum) && !isNaN(maxKmNum)) {
      // Check if min km is greater than max km
      if (minKmNum > maxKmNum) {
        this.kmValidationErrors[i] = `Min KM (${minKmNum}) cannot be greater than Max KM (${maxKmNum}) for ${partnerName}`;
        return false;
      }
    }

    return true;
  }

  validateAllKmRanges() {
    let hasErrors = false;
    for (let i = 0; i < this.UserDeliveryPartnerMap.length; i++) {
      if (!this.validateKmRange(i)) {
        hasErrors = true;
      }
    }
    return !hasErrors;
  }

  interChangeList(item: any) {
    var changeItem = [] = item;
    this.UserDeliveryPartnerMap = [...changeItem];

    // Revalidate km ranges after reordering
    this.UserDeliveryPartnerMap.forEach((element: any, index: any) => {
      this.validateKmRange(index);
    });
  }

  addDeliveryPartner() {
    this.submitted = true;
    if (this.dpFormGroup.valid) {
      var reqData: any = [{
        delivery_partner_user_id: this.dpFormGroup.value.delivery_partner_user_id,
        user_id: this.userData.userId,
        waiting_time_in_min: this.dpFormGroup.value.waiting_time_in_min,
        master_agency_user_id: this.userData.master_agency_user_id,
        agency_user_id: this.userData.agency_user_id,
        full_name: this.userData.fullName,
        dp_name: this.dp_name,
        status: "Active",
        sort_order: null,
      }]
      if (this.UserDeliveryPartnerMap) {
        reqData[0].sort_order = this.UserDeliveryPartnerMap.length + 1
      } else {
        reqData[0].sort_order = 1;
      };
      if (!this.validateAllKmRanges()) {
        // Find the first error and show it
        for (let i = 0; i < this.UserDeliveryPartnerMap.length; i++) {
          if (this.kmValidationErrors[i]) {
            this.toaster.error(this.kmValidationErrors[i]);
            break;
          }
        }
        return;
      }
      this.UserDeliveryPartnerMap.forEach((item: any) => {
        if (_.isEmpty(item.min_km)) { item.min_km = null };
        if (_.isEmpty(item.max_km)) { item.max_km = null };
      });
      this.http.postData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.DeliveryPartnerWiseOrderTime.DpOrderMap, reqData).subscribe((response: any) => {
        if (response.status) {
          this.toaster.success('Delivery partner added successfully');
          this.dp_name = null;
          this.submitted = false;
          this.deliveryPartnerShow = true;
          this.getDeliveryPartnerDetails();
        } else {
          this.toaster.error(response.message || 'Failed to add delivery partner');
        }
      })
    }
  }
  thirdPartyname(event: any) {
    this.dp_name = event.full_name;
    if (this.dp_push_mechanisum == 'Parallel') {
      this.dpFormGroup.get('waiting_time_in_min')?.setValue(1);
    }
  }
  checkValue(event: any) {
    var reqJson: any = {
      dp_rearrange_with_eta: this.dp_rearrange_with_eta,
      user_id: this.userData.userId,
      under_user_id: this.userData.under_user_id,
      agency_user_id: this.userData.agency_user_id,
      master_agency_user_id: this.userData.master_agency_user_id,
      vendor_agency_user_id: this.userData.vendor_agency_user_id,
      under_role_id: this.userData.under_role_id,
    }
    this.dpRearrangEvent.emit({ user_id: this.userData.userId, dp_rearrange_with_eta: this.dp_rearrange_with_eta });
    // if (event.target.checked) reqJson.dp_rearrange_with_eta = this.dp_rearrange_with_eta;
    this.http.updateData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.User.Update, reqJson).subscribe((response: any) => {
      if (response.status) {
        this.toaster.success('Successfully Updated')
      } else {
        this.toaster.error(response.message)
      }
    });
  }
  allowCod(event: any, i: any) {
    this.UserDeliveryPartnerMap[i].allow_cod = event?.target?.checked;
    // this.updateData();
  }
  activeAndInactive(event: any, i: any) {
    this.UserDeliveryPartnerMap[i].status = (event?.target?.checked) ? 'Active' : 'InActive';
    // if(this.UserDeliveryPartnerMap[i].delivery_partner_user_id == constant.deliveryPartnerViaOndc){
    //   this.ondcActiveCheck = (event?.target?.checked) ? true : false;
    // }
    var removeItem = {}
    if (!event.target.checked) {
      this.UserDeliveryPartnerMap.forEach((element: any, index: any) => {
        if (index == i) {
          removeItem = element;
          this.UserDeliveryPartnerMap.splice(index, 1)
        };
      });
      this.UserDeliveryPartnerMap.push(removeItem);
    }
    // this.updateData();
  }

  //   updateData() {
  //     var requiredWaitingTime: boolean = true;

  //     // Validate all km ranges first
  //     if (!this.validateAllKmRanges()) {
  //       // Find the first error and show it
  //       for (let i = 0; i < this.UserDeliveryPartnerMap.length; i++) {
  //         if (this.kmValidationErrors[i]) {
  //           this.toaster.error(this.kmValidationErrors[i]);
  //           break;
  //         }
  //       }
  //       return;
  //     }

  //     this.UserDeliveryPartnerMap.map((item: any, i: any) => {
  //       item.master_agency_user_id = this.userData.master_agency_user_id,
  //         item.agency_user_id = this.userData.agency_user_id,
  //         item.full_name = this.userData.fullName,
  //         item.sort_order = i + 1
  //       if (!Number(item?.waiting_time_in_min) && item.status == 'Active') {
  //         this.toaster.error(`Please fill waiting time for ${item?.DeliveryPartner?.full_name}`);
  //         return requiredWaitingTime = false;
  //       } else if (!item?.waiting_time_in_min) {
  //         item.waiting_time_in_min = 1;
  //       }
  //       return item;
  //     });
  //     this.UserDeliveryPartnerMap.forEach((item: any) => {
  //       if(_.isEmpty(item.min_km)){item.min_km = null};
  //       if(_.isEmpty(item.max_km)){item.max_km = null};
  //     });
  //   const isOndcMapped = this.UserDeliveryPartnerMap.some((x: any) => x.delivery_partner_user_id === constant.deliveryPartnerViaOndc && x.status === 'Active');    

  //     if(!isOndcMapped  ){
  //        if (requiredWaitingTime) {
  //       this.http.postData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.DeliveryPartnerWiseOrderTime.DpOrderMap, this.UserDeliveryPartnerMap).subscribe((response: any) => {
  //         if (response.status) {
  //           this.UserDeliveryPartnerMap?.map((element: any) => {
  //             delete element.previous_json;
  //             element.previous_json = { ...element };
  //           })
  //           this.toaster.success(response.message)
  //         }
  //       }) 
  //     }
  //   }else{

  //     const dp$ = this.http  .postData(constant.Service.MainMaster.BaseUrl +constant.Service.MainMaster.DeliveryPartnerWiseOrderTime.DpOrderMap,this.UserDeliveryPartnerMap).pipe(map((res: any) => ({  success: res?.status == true,response: res as ApiResponse}) as ApiResult),catchError(error =>of({ success: false, error } as ApiResult)));

  //     const ondc$ = this.http.postData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.DeliveryPartnerWiseOrderTime.OndcConfig, {user_id: this.userData.userId, ondc_3pl_config: _.isEmpty(this.ondcConfigListData)?null:this.ondcConfigListData },)
  //       .pipe(map((res: any) => ({success: res?.status === true,response: res as ApiResponse}) as ApiResult),catchError(error =>of({ success: false, error } as ApiResult))  );

  //    combineLatest([dp$, ondc$]).subscribe(([dp, ondc]) => {
  //     if(dp?.success){
  //       this.UserDeliveryPartnerMap?.map((element: any) => {
  //       delete element.previous_json;
  //       element.previous_json = { ...element };
  //     })
  //     } 
  //    if (dp.success && ondc.success) {
  //     this.toaster.success(' updated successfully');
  //   }
  //    else if (!dp.success && !ondc.success) {
  //     this.toaster.error('updated failed');
  //   }
  //    else {    
  //     if (dp.success) {
  //       this.toaster.success(dp.response!.message);
  //     } else {
  //       this.toaster.error('Delivery update failed');
  //       return
  //     }

  //     if (ondc.success) {
  //        this.toaster.success(ondc.response!.message);
  //     } else {
  //       this.toaster.error('ONDC update failed');
  //       return
  //     }
  //   }
  // });
  //     }
  //   }
  updateData() {
    var requiredWaitingTime: boolean = true;

    // Validate all km ranges first
    if (!this.validateAllKmRanges()) {
      // Find the first error and show it
      for (let i = 0; i < this.UserDeliveryPartnerMap.length; i++) {
        if (this.kmValidationErrors[i]) {
          this.toaster.error(this.kmValidationErrors[i]);
          break;
        }
      }
      return;
    }

    this.UserDeliveryPartnerMap.map((item: any, i: any) => {
      item.master_agency_user_id = this.userData.master_agency_user_id,
        item.agency_user_id = this.userData.agency_user_id,
        item.full_name = this.userData.fullName,
        item.sort_order = i + 1
      if (!Number(item?.waiting_time_in_min) && item.status == 'Active') {
        this.toaster.error(`Please fill waiting time for ${item?.DeliveryPartner?.full_name}`);
        return requiredWaitingTime = false;
      } else if (!item?.waiting_time_in_min) {
        item.waiting_time_in_min = 1;
      }
      return item;
    });
    this.UserDeliveryPartnerMap.forEach((item: any) => {
      if (_.isEmpty(item.min_km)) { item.min_km = null };
      if (_.isEmpty(item.max_km)) { item.max_km = null };
    });
    if (requiredWaitingTime) {
      this.http.postData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.DeliveryPartnerWiseOrderTime.DpOrderMap, this.UserDeliveryPartnerMap).subscribe((response: any) => {
        if (response.status) {
          this.UserDeliveryPartnerMap?.map((element: any) => {
            delete element.previous_json;
            element.previous_json = { ...element };
          })
          this.toaster.success(response.message)
        }
      })
    }
  }
  deleteDeliveryPartner(event: any, index: any) {
    Swal.fire({
      title: 'Would you like to remove the delivery partner?',
      text: "",
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        // Clear validation error for this index
        delete this.kmValidationErrors[index];

        let Url = constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.DeliveryPartnerWiseOrderTime.DeleteDp + '?delivery_partner_user_id=' + event.delivery_partner_user_id + '&vendor_user_id=' + this.userData.userId + '&dp_name=' + event.DeliveryPartner.full_name + '&full_name=' + this.userData.fullName
        if (this.userData?.agency_user_id) {
          Url += '&agency_user_id=' + this.userData?.agency_user_id
        }
        if (this.userData?.master_agency_user_id) {
          Url += '&master_agency_user_id=' + this.userData?.master_agency_user_id
        }
        this.http.deleteDataParams(Url).subscribe((response: any) => {
          if (response.status) {
            // if(constant.deliveryPartnerViaOndc==event.delivery_partner_user_id&&this.ondcActiveCheck){
            //   this.ondcConfigListData = [];
            //   this.userData.ondc_bap_id="";
            // }
            this.toaster.success(response.message);
            this.getDeliveryPartnerDetails();
          }
        })
      }
    })
  }

  changeToOwnSetup() {
    // Find the Own option in dpList
    console.log("dp_setup", this.dp_setup);
    console.log("dpList", this.dpList);
    const ownOption = this.dpList.find((item: any) => item.value === constant.dpSetup.own);
    if (ownOption) {
      this.dp_setup = constant.dpSetup.own;
      // this.apply_dp_setup = constant.dpSetup.own;
      this.dpSetupMethod(); // This will trigger the API call to update the setup
      this.toaster.info('Switching to Own setup...');
    } else {
      this.toaster.error('Own setup option not available');
    }
  }
  customerCluster() {
    // this.router.navigate(['/settings/clustercustomerwise']);
    var url = window?.location?.origin;
    if (url.includes('child')) {
      window.open(window?.location?.origin + '/settings/clustercustomerwise?id=' + this.userData.userId, "_blank");
    } else {
      window.open(window?.location?.origin + '/app/settings/clustercustomerwise?id=' + this.userData.userId, "_blank");
    }
    // this.activeModal.close();

  }
}
// Add waitingTimeValidator before the component class
function waitingTimeValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;

  // Check if value is null or undefined
  if (value === null || value === undefined || value === '') {
    return { required: true };
  }

  // Convert to number
  const numValue = Number(value);

  // Check if it's a valid number
  if (isNaN(numValue)) {
    return { invalidNumber: true };
  }

  // Check if it's negative
  if (numValue < 0) {
    return { negativeValue: true };
  }

  // Check if it's less than 1 or greater than 60
  if (numValue < 1 || numValue > 60) {
    return { outOfRange: true };
  }

  return null;
}